/** Payload shape returned inside each GraphQL operation field. */
export type GraphQLCodePayload = {
  code: string;
};

export type GraphQLData<
  TPayload extends GraphQLCodePayload,
  TOperation extends string
> = Record<TOperation, TPayload>;

/** Unwrap `{ operationName: { code, ... } }` from fetchGraphQL result.data. */
export function unwrapGraphQLOperation<
  TPayload extends GraphQLCodePayload,
  TOperation extends string
>(data: GraphQLData<TPayload, TOperation>, operation: TOperation): TPayload {
  const payload = data[operation];
  if (!payload) {
    throw new Error(`Missing GraphQL operation payload: ${operation}`);
  }
  return payload;
}
